import React, { useEffect, useState } from "react";
import "./Confetti.css";

const Confetti = ({ isVisible }) => {
  const [confetti, setConfetti] = useState([]);

  useEffect(() => {
    if (isVisible) {
      // Create confetti pieces with different colors and positions
      const newConfetti = Array.from({ length: 50 }, (_, index) => ({
        id: index,
        color: getRandomColor(),
        left: Math.random() * 100, // Random horizontal position
        delay: Math.random() * 3, // Random delay for staggered animation
        size: 8 + Math.random() * 12, // Random size between 8-20px
        rotation: Math.random() * 360, // Random rotation
        shape: Math.random() > 0.5 ? "square" : "circle", // Random shape
      }));
      setConfetti(newConfetti);
    } else {
      setConfetti([]);
    }
  }, [isVisible]);

  const getRandomColor = () => {
    const colors = [
      "#FF6B6B", // Red
      "#4ECDC4", // Teal
      "#45B7D1", // Blue
      "#96CEB4", // Green
      "#FFEAA7", // Yellow
      "#DDA0DD", // Plum
      "#FFB347", // Orange
      "#98D8C8", // Mint
      "#F7DC6F", // Gold
      "#BB8FCE", // Purple
    ];
    return colors[Math.floor(Math.random() * colors.length)];
  };

  if (!isVisible) return null;

  return (
    <div className="confetti-container">
      {confetti.map((piece) => (
        <div
          key={piece.id}
          className={`confetti-piece ${piece.shape}`}
          style={{
            left: `${piece.left}%`,
            backgroundColor: piece.color,
            width: `${piece.size}px`,
            height: `${piece.size}px`,
            animationDelay: `${piece.delay}s`,
            transform: `rotate(${piece.rotation}deg)`,
          }}
        />
      ))}
    </div>
  );
};

export default Confetti;
